import { Clickable } from "artisn-ui-react";
import { useRouter } from "next/router";
import React from "react";

import Styles from "./GoBack.styles";
import { GoBackProps as Props } from "./GoBack.types";

import ChevronLeft from "../../../../public/assets/images/chevron-left-black.svg";

const GoBack: React.FC<Props> = props => {
  const { title = "", width = 0, icon, className, to } = props;
  const router = useRouter();

  const clickHandler = () => {
    if (to) {
      router.replace(to);
      return;
    }

    const history = window.history;

    if (history.length <= 1) {
      router.push("/");
      return;
    }

    router.back();
  };

  return (
    <Styles className={`GoBack ${className}`} width={width} title={title}>
      <Clickable onClick={clickHandler} className="GoBack__icon">
        {icon ?? <ChevronLeft />}
        {title ? <p className="GoBack__title">{title}</p> : null}
      </Clickable>
    </Styles>
  );
};

GoBack.defaultProps = {
  className: ""
};

export default GoBack;
